/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CommunityInputs */

const en_community = /** @type {(inputs: CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community`)
};

const id_community = /** @type {(inputs: CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komunitas`)
};

/** @type {(inputs: CommunityInputs) => LocalizedString} */
const es_community = en_community;

/** @type {(inputs: CommunityInputs) => LocalizedString} */
const fr_community = en_community;

/** @type {(inputs: CommunityInputs) => LocalizedString} */
const de_community = en_community;

/** @type {(inputs: CommunityInputs) => LocalizedString} */
const ja_community = en_community;

/** @type {(inputs: CommunityInputs) => LocalizedString} */
const zh_community = en_community;

/** @type {(inputs: CommunityInputs) => LocalizedString} */
const ar_community = en_community;

/** @type {(inputs: CommunityInputs) => LocalizedString} */
const it_community = en_community;

/** @type {(inputs: CommunityInputs) => LocalizedString} */
const ru_community = en_community;

/** @type {(inputs: CommunityInputs) => LocalizedString} */
const pt_community = en_community;

/** @type {(inputs: CommunityInputs) => LocalizedString} */
const ko_community = en_community;

/**
* | output |
* | --- |
* | "Community" |
*
* @param {CommunityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const community = /** @type {((inputs?: CommunityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CommunityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_community(inputs)
	if (locale === "es") return es_community(inputs)
	if (locale === "fr") return fr_community(inputs)
	if (locale === "de") return de_community(inputs)
	if (locale === "ja") return ja_community(inputs)
	if (locale === "zh") return zh_community(inputs)
	if (locale === "ar") return ar_community(inputs)
	if (locale === "id") return id_community(inputs)
	if (locale === "it") return it_community(inputs)
	if (locale === "ru") return ru_community(inputs)
	if (locale === "pt") return pt_community(inputs)
	return ko_community(inputs)
});